import { render } from "./Eye.vue?vue&type=template&id=58b604b7"
const script = {}
script.render = render

export default script